import { create } from 'zustand';
import { apiClient } from '../api/client';
import type { User } from '../types';

interface TechniciansState {
  technicians: User[];
  loaded: boolean;
  loading: boolean;
  load: () => void;
  reload: () => void;
}

// Список сантехников почти не меняется в течение смены диспетчера, а раньше каждый
// компонент (Список/Канбан/Календарь/Отчёты) грузил его заново при каждом переключении
// вкладки — теперь грузим один раз на сессию и раздаём всем из общего стора.
//
// Но «один раз на сессию» оказалось слишком буквально: заведённый новый сантехник не
// появлялся в списках назначения, пока диспетчер не перезагрузит страницу (WEB-5).
// Поэтому есть reload — его дёргает Layout по сигналу «сотрудники изменились» с сервера
export const useTechniciansStore = create<TechniciansState>((set, get) => {
  function fetchTechnicians() {
    set({ loading: true });
    apiClient
      .get<User[]>('/users/technicians')
      .then(({ data }) => {
        set({ technicians: data, loaded: true, loading: false });
      })
      .catch((err) => {
        console.error('Не удалось загрузить список сантехников', err);
        set({ loading: false });
      });
  }

  return {
    technicians: [],
    loaded: false,
    loading: false,
    load: () => {
      if (get().loaded || get().loading) return;
      fetchTechnicians();
    },
    reload: () => {
      if (get().loading) return;
      fetchTechnicians();
    },
  };
});
